module.exports = __webpack_public_path__ + "img/julia-dominguez-perrone.41cf5abb.jpg";